import {
  renderThreadDeleteAction,
  renderThreadDetailDrawerShell,
  renderThreadDetailTurnsSection
} from "../detail-shared.js";

export function renderLLMThreadDetailDrawer(detailState, options = {}) {
  const current = detailState.thread;
  if (!current) {
    return "";
  }

  const threadDiagnostics = detailState.threadDiagnostics;
  const renderContextRow = options.renderContextRow || (() => "");
  const lookupAgentName = options.lookupAgentName || ((value) => value || "unknown");
  const renderTurns = options.renderTurns || (() => `<div class="empty">No turns yet.</div>`);

  return renderThreadDetailDrawerShell(`
    <div class="panel-eyebrow">Thread context</div>
    <div class="list">
      ${renderContextRow("Thread ID", current.id)}
      ${renderContextRow("Mode", "llm")}
      ${renderContextRow("Agent", lookupAgentName(current.agent_id))}
      ${renderContextRow("State", current.state)}
      ${renderContextRow("Last request", threadDiagnostics?.last_request_id || current.last_request_id || "n/a")}
      ${renderContextRow("Turns", String(detailState.turns.length))}
    </div>
    ${renderThreadDetailTurnsSection(renderTurns(detailState.turns))}
    ${renderThreadDeleteAction()}
  `);
}
